"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

import { Link } from "@/navigation";

const NAMESPACE = "new-3d-printing";

const IMAGE_BASE = "/image/new-version/more/3D-Printing/Finishing-Post-Processing-Services";

const CARDS = [
	{ keyPrefix: "finishingPostProcessingCard1", image: `${IMAGE_BASE}/as-machined.webp` },
	{ keyPrefix: "finishingPostProcessingCard2", image: `${IMAGE_BASE}/customizable-painting.webp` },
	{ keyPrefix: "finishingPostProcessingCard3", image: `${IMAGE_BASE}/high-efficiency-polishing.webp` },
	{ keyPrefix: "finishingPostProcessingCard4", image: `${IMAGE_BASE}/standardized-electroplating.webp` },
] as const;

const MORE_HREF = "/surface-finishing";

export default function FinishingPostProcessing() {
	const t = useTranslations(NAMESPACE);

	return (
		<section className="bg-[#ededed] py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<header className="mb-6 flex flex-col gap-4 sm:mb-8 md:mb-10 md:flex-row md:items-start md:justify-between md:gap-8 lg:mb-12 lg:gap-12">
					<h2 className="shrink-0 text-2xl font-bold leading-tight text-black sm:text-[30px] md:text-4xl lg:max-w-[520px]">
						{t("finishingPostProcessingTitle")}
					</h2>
					<p className="text-sm leading-relaxed text-black md:min-w-0 md:flex-1 md:text-base lg:max-w-[640px]">
						{t("finishingPostProcessingDesc")}
					</p>
				</header>

				<div className="overflow-hidden border border-[#cccccc]">
					<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
						{CARDS.map((card) => (
							<article
								key={card.keyPrefix}
								className="border-b border-[#cccccc] bg-[#f3f3f3] p-6 last:border-b-0 sm:p-7 md:p-8 lg:border-b-0 lg:border-r lg:[&:last-child]:border-r-0 sm:[&:nth-child(-n+2)]:border-b sm:[&:nth-child(odd)]:border-r lg:[&:nth-child(odd)]:border-r sm:[&:nth-last-child(-n+2)]:border-b-0"
							>
								<h3 className="mb-4 text-base font-bold text-black sm:mb-5 sm:text-lg">
									{t(`${card.keyPrefix}Title`)}
								</h3>
								<div className="relative mx-auto mb-4 aspect-[4/3] w-full overflow-hidden bg-[#f5f7fa] sm:mb-5">
									<Image
										src={card.image}
										alt={t(`${card.keyPrefix}Alt`)}
										fill
										className="object-cover"
										sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 25vw"
									/>
								</div>
								<p className="text-sm leading-relaxed text-black md:text-base">
									{t(`${card.keyPrefix}Desc`)}
								</p>
							</article>
						))}
					</div>
				</div>

				<div className="mt-8 flex justify-center sm:mt-10 md:mt-12">
					<Link
						href={MORE_HREF}
						className="inline-flex items-center justify-center rounded bg-themePrimary400 px-6 py-3 text-sm font-semibold text-white transition-all duration-300 hover:bg-[#83b751] hover:text-white md:px-8 md:py-3.5 md:text-base"
					>
						{t("finishingPostProcessingMoreCta")}
					</Link>
				</div>
			</div>
		</section>
	);
}
